import IMAGES from "@/public/assets/img";

const exportFactoringInterest = {
  seoData: {
    title: "Interest Subvention on Export Factoring via GIFT City | Credlix",
    description: "Avail 2.75% interest subvention on Export Factoring via GIFT City. Get up to 90% working capital within 24 hours. Zero collateral, non-recourse factoring.",
  },

  badgeText: "DGFT Trade Notice February 20, 2026",
  bannerHeading:
  'Do you want to avail <br /> 2.75% Interest Subvention on<br /> <span class="text-[#E3A003] font-medium text-[72px] leading-[72px] md:text-headingbig sm:text-heading">Export Factoring</span> <br /> via GIFT City?',
  
  features: [
    {
      line1: "Zero Collateral",
      line1Bold: true,
      line2: "Required",
      line2Bold: false
    },
    {
      line1: "Funds in",
      line1Bold: false,
      line2: "as little as 48 hours",
      line2Bold: true
    },
    {
      line1: "Non-Recourse:",
      line1Bold: false,
      line2: "Buyer default <strong>protection</strong>",
      line2Bold: false
    }
  ],

  benefits: [
    {
      id: 1,
      icon: IMAGES?.exportInterest.fci,
      text: "FCI Member Since 2021",
    },
    {
      id: 2,
      icon: IMAGES?.dealerFinancing.msme,
      text: "90+ Export Buyer Countries",
    },
    {
      id: 3,
      icon: IMAGES?.dealerFinancing.cities,
      text: "IFSCA Registered GIFT City Entity",
    },
    {
      id: 4,
      icon: IMAGES?.dealerFinancing.RBILogo,
      text: "RBI-Registered NBFC Partner",
    },
  ],

  exportMoney: {
    heading: "Why Exporters are leaving money on the table",
    subHeading: "Indian MSMEs drive 45% of the country's exports yet most are still financing growth with expensive, collateral-heavy bank credit and waiting 60–120 days to get paid. There is now a better way.",
    cards: [
      {
        id: 1,
        title: "Payment terms of 60-120 days",
        description: "Buyers pay on long credit cycles, locking your cash for months",
        icon: IMAGES?.exportInterest.payment,
      },
      {
        id: 2,
        title: "Bank export credit: slow and collateral-heavy",
        description: "Banks demand collateral, paperwork, and weeks–making MSME access tough and costly",
        icon: IMAGES?.exportInterest.bankCredit,
      },
      {
        id: 3,
        title: "Buyer default risk with no cover",
        description: "One unpaid invoice can wipe out months of margins without protection",
        icon: IMAGES?.exportInterest.risk,
      }
    ],
    opportunity: {
      percentage: "2.75%",
      subventionText: "GOVERNMENT SUBVENTION ON FACTORING COST",
      title: "The opportunity most exporters don't know about",
      description: "Under DGFT Trade Notice 25/2025–26 (Export Promotion Mission, NIRYAT PROTSAHAN), eligible MSME exporters can receive a 2.75% interest subvention on export factoring costs — up to ₹50 lakh per financial year. On a ₹10 Cr export book, that's ₹27.5 lakh+ savings annually. Most exporters haven't leveraged this yet. With Credlix, you can."
    }
  },

  credlixVsOthers: {
    heading: "What you get with Credlix <br /> that <span class='text-[#e3a200]'>others</span> don't",
    headers: {
      credlix: "Credlix",
      others: "Typical Bank / Other Fintech"
    },
    features: [
      {
        id: 1,
        title: "Active guidance on 2.75% interest subvention",
        iconType: "guidance",
        credlix: "Yes",
        others: "Rarely offered"
      },
      {
        id: 2,
        title: "Advance up to 90% of invoice value",
        iconType: "advance",
        credlix: "Yes",
        others: "60–80% typically"
      },
      {
        id: 3,
        title: "Zero collateral required",
        iconType: "collateral",
        credlix: "Yes",
        others: "Collateral usually needed"
      },
      {
        id: 4,
        title: "Funds within 48 hours of upload",
        iconType: "funds",
        credlix: "Yes",
        others: "7-21 days typically"
      },
      {
        id: 5,
        title: "Non-recourse (buyer default protection)",
        iconType: "nonRecourse",
        credlix: "Yes",
        others: "Recourse in most cases"
      },
      {
        id: 6,
        title: "Free buyer credibility report",
        iconType: "credibility",
        credlix: "Yes",
        others: "Not included"
      },
      {
        id: 7,
        title: "Multi-currency ($, £)",
        iconType: "currency",
        credlix: "Yes",
        others: "Limited or INR only"
      },
      {
        id: 8,
        title: "Buyers in 90+ countries covered",
        iconType: "coverage",
        credlix: "Yes",
        others: "Selective geographies"
      }
    ]
  },

  exportSavings: {
    heading: "Your savings with the <span class='text-[#e3a200]'>2.75% interest subvention</span>",
    subHeading: "Here's how the numbers can look for a typical MSME exporter (illustrative; actual savings depend on eligibility, facility terms, and scheme conditions).",
    withoutSubvention: {
      title: "WITHOUT SUBVENTION",
      value: "~11-12%",
      description: "Typical effective annual cost of export factoring or working capital financing for an MSME without government support."
    },
    withSubvention: {
      title: "WITH CREDLIX + 2.75% SUBVENTION (ELIGIBLE MSMES)",
      value: "~8-9%",
      description: "Effective cost of funds after the 2.75% government interest subvention is applied – a meaningful improvement to your working capital margin.",
      buttonText: "Apply Now"
    }
  },

  exportProcess: {
    heading: "How Credlix export factoring + the 2.75% subvention works",
    subHeading: "A simple, fully digital process – from invoice to cash in as little as 48 hours.",
    steps: [
      {
        id: 1,
        title: "Ship & raise invoice",
        description: "Complete your export shipment and generate your export invoice as usual."
      },
      {
        id: 2,
        title: "Submit to Credlix",
        description: "Upload invoice documents on our digital platform – 100% online, no branch visits."
      },
      {
        id: 3,
        title: "Receive advance",
        description: "Get up to 90% of invoice value credited to your account within 48 hours."
      },
      {
        id: 4,
        title: "Buyer pays Credlix",
        description: "Your overseas buyer pays on their normal credit terms. We manage collections."
      },
      {
        id: 5,
        title: "Balance + subvention",
        description: "You receive the balance. Eligible MSMEs claim the 2.75% subvention via DGFT portal."
      }
    ]
  },

  whoShouldApply: {
    heading: "Who should apply",
    subHeading: "Credlix export factoring works best for the following profile. For the 2.75% interest subvention, additional DGFT eligibility criteria apply — confirmed in your free consultation.",
    points: [
      "MSME with valid Udyam Registration & Importer-Exporter Code (IEC)",
      "Annual export turnover of ₹50 lakh and above",
      "Exporting to US, Europe, or other developed/investment-grade markets",
      "Products falling within the DGFT notified positive list (4,139 HS tariff lines – textiles, engineering goods, chemicals, leather, agro-products, and many more)",
      "Selling on open-account terms or willing to transition from LC-based trade",
      "Existing or new exporters – Credlix works with both"
    ],
    infoText: "Subvention is not available for deemed exports, SEZ supplies, or export factoring through non-RBI/IFSCA regulated entities."
  },

  exportGains: {
    heading: "What MSME exporters gain with Credlix",
    items: [
      {
        id: 1,
        title: "Lower Cost of Funds",
        imageKey: "lowerCost",
        points: [
          "Up to 2.75% lower cost for eligible exporter",
          "Competitive rates – no collateral required",
          "Price more aggressively, protect margins"
        ]
      },
      {
        id: 2,
        title: "Better Cash Flow",
        imageKey: "betterCash",
        points: [
          "Up to 90% advance in 48 hours",
          "Unlock capital to take larger orders",
          "Covers pre & post-shipment finance"
        ]
      },
      {
        id: 3,
        title: "Lower risk, more confidence",
        imageKey: "lowerRisk",
        points: [
          "Non-recourse: we take buyer default risk",
          "Free buyer credit checks",
          "No collateral- based on invoice & buyer strength"
        ]
      }
    ]
  },

  exportCta: {
    heading: "Lower your export factoring cost by <span class='text-[#e3a200]'>2.75%</span> and unlock faster cash flow",
    subHeading: "Join MSME exporters who are combining Credlix’s digital-first factoring with the Government of India’s interest subvention to finance growth on better terms.",
    bookBtnText: "Book a 15-Min Free Consultation",
    checkBtnText: "Check Subvention Eligibility",
    trustText: "No obligation  •  Response within 1 business day  •  Your data is secure"
  },

  FaqHead: "Frequently Asked Questions",
  Faq: [
    {
      id: 0,
      question: "What is export factoring and how is it different from a bank loan?",
      answers:
        "Export factoring converts your unpaid export invoices into immediate working capital without adding debt to your balance sheet. Unlike a bank loan, factoring is based on the quality of your buyer and invoice rather than your balance sheet or collateral. Credlix advances up to 90% of the invoice value and collects payment from your buyer when due, making it an asset-based and balance-sheet-light financing solution."
    },
    {
      id: 1,
      question: "How does the 2.75% government interest subvention work?",
      answers:
        "Under DGFT Trade Notice 25/2025–26 (Export Promotion Mission – Niryat Protsahan), eligible MSME exporters can claim a 2.75% interest subvention on the factoring cost paid on export receivable transactions. This reduces the effective cost of funds and is capped at ₹50 lakh per MSME per financial year. Credlix helps eligible exporters structure factoring facilities through RBI-regulated channels and navigate the claim process."
    },
    {
      id: 2,
      question: "Who is eligible for the 2.75% interest subvention?",
      answers:
        "Eligible exporters generally require a valid Importer Exporter Code (IEC) and Udyam MSME Registration. Exported products must fall within the DGFT's positive list of eligible HS tariff lines. The factoring facility must be with an RBI- or IFSCA-regulated entity. Deemed exports and SEZ supplies do not qualify. Eligibility is confirmed during the Credlix consultation process."
    },
    {
      id: 3,
      question: "Can I use Credlix alongside my existing bank export credit facility?",
      answers:
        "Yes. Credlix complements your existing banking relationships rather than replacing them. Many exporters use bank packing credit limits for pre-shipment funding and Credlix export factoring for post-shipment receivables, helping maximise overall working capital and manage buyer risk."
    },
    {
      id: 4,
      question: "What is the typical timeline from application to fund disbursal?",
      answers:
        "For new clients, onboarding generally takes 3 to 5 business days, subject to documentation requirements. Once the facility is established, invoice submissions are processed digitally and funds are typically disbursed within 48 hours after invoice verification."
    },
    {
      id: 5,
      question: "What does non-recourse factoring mean?",
      answers:
        "In non-recourse factoring, Credlix bears the risk of buyer non-payment arising from insolvency or prolonged default. Unlike recourse factoring, where the exporter may need to repay the advance if the buyer defaults, non-recourse factoring provides added protection and peace of mind."
    },
    {
      id: 6,
      question: "What documents are needed to get started?",
      answers:
        "Typical requirements include PAN, Aadhaar, GST Registration, IEC, Udyam Certificate, the last 12 months of bank statements, export invoices, shipping bills, and buyer details. Credlix's digital platform guides exporters through the document submission process online."
    },
    {
      id: 7,
      question: "Is my data secure with Credlix?",
      answers:
        "Yes. Credlix operates under a regulated NBFC framework and follows RBI guidelines for data governance and customer privacy. All information submitted through the platform is encrypted both in transit and at rest, and data is shared only when required for credit assessment or regulatory compliance."
    }
  ]
};

export default exportFactoringInterest;
